var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1100",
      "scrollable": "",
      "content-class": "score-detail-dialog"
    },
    model: {
      value: _vm.intDialogVisible,
      callback: function callback($$v) {
        _vm.intDialogVisible = $$v;
      },
      expression: "intDialogVisible"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5"
  }, [_vm._v(" Скоринг клиента "), _vm.score && _vm.score.hasContract ? _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": "",
      "color": "blue",
      "title": "По этому номеру уже есть договор"
    }
  }, [_vm._v("mdi-file-document-check-outline")]) : _vm._e()], 1), _c('v-card-text', [_vm.notFound ? _c('div', [_vm._v(" Клиент ещё не оценён. ")]) : _vm.score ? _c('div', [_c('div', {
    staticClass: "mb-2"
  }, [_c('v-chip', {
    attrs: {
      "dark": "",
      "color": _vm.$helper.aiScoreColor(_vm.score.score)
    }
  }, [_vm._v(" " + _vm._s(_vm.score.score) + " ")]), _vm.score.probability !== null && _vm.score.probability !== undefined ? _c('span', {
    staticClass: "ml-2 grey--text"
  }, [_vm._v(" вероятность " + _vm._s((_vm.score.probability * 100).toFixed(0)) + "% ")]) : _vm._e()], 1), _vm.score.promptVersion === 'v1' ? _c('div', {
    staticClass: "mb-2 grey--text text-caption"
  }, [_c('v-icon', {
    attrs: {
      "x-small": "",
      "color": "grey"
    }
  }, [_vm._v("mdi-information-outline")]), _vm._v(" Оценка перенесена со старой модели скоринга, будет пересчитана при следующем событии. ")], 1) : _vm._e(), _vm.score.summary ? _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm._v("Резюме по клиенту")]), _c('div', [_vm._v(_vm._s(_vm.score.summary))])]) : _vm._e(), _vm.score.recommendations && _vm.score.recommendations.length ? _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm._v("Рекомендации оператору")]), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.score.recommendations, function (recommendation, i) {
    return _c('v-list-item', {
      key: i,
      staticClass: "px-0"
    }, [_c('v-list-item-icon', {
      staticClass: "mr-2"
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "amber darken-2"
      }
    }, [_vm._v("mdi-lightbulb-on-outline")])], 1), _c('v-list-item-content', [_vm._v(_vm._s(recommendation))])], 1);
  }), 1)], 1) : _vm._e(), _vm.score.reasoning ? _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm._v("Обоснование")]), _c('div', [_vm._v(_vm._s(_vm.score.reasoning))])]) : _vm._e(), _vm.score.lastChangeReason ? _c('div', {
    staticClass: "mb-2 grey--text"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Что изменилось")]), _c('div', [_vm._v(_vm._s(_vm.score.lastChangeReason))])]) : _vm._e(), _vm.hasChecklist ? _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-caption grey--text"
  }, [_vm._v("Контроль оператора (последний звонок)")]), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.checklistEntries, function (entry) {
    return _c('v-list-item', {
      key: entry.label,
      staticClass: "px-0"
    }, [_c('v-list-item-icon', {
      staticClass: "mr-2"
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": _vm.checklistColor(entry.item)
      }
    }, [_vm._v(_vm._s(_vm.checklistIcon(entry.item)))])], 1), _c('v-list-item-content', [_c('span', [_vm._v(_vm._s(entry.label))]), entry.item.comment ? _c('span', {
      staticClass: "grey--text text-caption ml-1"
    }, [_vm._v("— " + _vm._s(entry.item.comment))]) : _vm._e()])], 1);
  }), 1)], 1) : _vm._e(), _vm.score.signals && _vm.score.signals.length ? _c('v-chip-group', {
    staticClass: "mb-2",
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.score.signals, function (signal, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "small": "",
        "outlined": ""
      }
    }, [_vm._v(" " + _vm._s(signal) + " ")]);
  }), 1) : _vm._e(), _c('v-expansion-panels', {
    staticClass: "mt-2",
    attrs: {
      "flat": ""
    },
    on: {
      "change": function change($event) {
        return _vm.loadHistory();
      }
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v(" История изменений "), _vm.score.recomputeCount ? _c('span', {
    staticClass: "grey--text text-caption ml-2"
  }, [_vm._v(" (" + _vm._s(_vm.score.recomputeCount) + ") ")]) : _vm._e()]), _c('v-expansion-panel-content', [_vm.historyLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-two-line@3"
    }
  }) : !_vm.history.length ? _c('div', {
    staticClass: "grey--text"
  }, [_vm._v("История пуста.")]) : _c('v-expansion-panels', {
    attrs: {
      "accordion": "",
      "flat": ""
    }
  }, _vm._l(_vm.history, function (item) {
    return _c('v-expansion-panel', {
      key: item.id
    }, [_c('v-expansion-panel-header', {
      staticClass: "px-0"
    }, [_c('div', [_c('span', {
      staticClass: "text-caption grey--text"
    }, [_vm._v(_vm._s(_vm.$moment(item.createdAt).dateTimeFormat()))]), _c('span', {
      staticClass: "ml-2"
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": _vm.scoreDeltaColor(item)
      }
    }, [_vm._v(_vm._s(_vm.scoreDeltaIcon(item)))]), _vm._v(" " + _vm._s(item.previousScore === null ? '—' : item.previousScore) + " → " + _vm._s(item.newScore === null ? '—' : item.newScore) + " ")], 1), _c('span', {
      staticClass: "ml-2 grey--text text-caption"
    }, [_vm._v(_vm._s(_vm.$helper.scoreTriggerLabel(item.trigger)))])])]), _c('v-expansion-panel-content', {
      staticClass: "px-0"
    }, [item.changeReason ? _c('div', {
      staticClass: "mb-1"
    }, [_vm._v(_vm._s(item.changeReason))]) : _vm._e(), item.summary ? _c('div', {
      staticClass: "mb-1 grey--text"
    }, [_vm._v(_vm._s(item.summary))]) : _vm._e(), item.recommendations && item.recommendations.length ? _c('ul', _vm._l(item.recommendations, function (r, i) {
      return _c('li', {
        key: i
      }, [_vm._v(_vm._s(r))]);
    }), 0) : _vm._e()])], 1);
  }), 1)], 1)], 1)], 1)], 1) : _vm._e()]), _c('v-card-actions', [_vm.canRecompute ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "loading": _vm.recomputing
    },
    on: {
      "click": function click($event) {
        return _vm.recompute();
      }
    }
  }, [_vm._v(" Пересчитать ")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.intDialogVisible = false;
      }
    }
  }, [_vm._v("Закрыть")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }